import { Observable } from 'rxjs';
import { DynamicModification } from '../../models/dynamic-modification';
import { ViewerService } from '../../services/viewer.service';
import { Action } from './action';
import { AddDmOperation } from './operations/add-dm-operation';
import { DeleteDmOperation } from './operations/delete-dm-operation';
import { Operation } from './operations/operation';

export class AddDMAction extends Action {

    names: Array<string>;
    viewerService: ViewerService;

    protected operation: Operation;
    protected reverseOperation: Operation;

    private appeazUrl: string;
    private stepId: string;
    private idAppeaz: number;
    private appeazRole: string;
    private readonly isPhotoImport: boolean;

    private shadowPlaceholder: HTMLDivElement;

    constructor(viewerService: ViewerService, idAppeaz: number, appeazUrl: string, appeazRole: string, stepId: string,
        dynamicModifications: Array<DynamicModification>, rank: number, shadowPlaceholder: HTMLDivElement, isPhotoImport: boolean) {
        super();
        this.viewerService = viewerService;
        this.names = [];
        dynamicModifications.forEach(dynamicModification => {
            this.names.push(dynamicModification.modificationTarget.label);
        });
        this.appeazUrl = appeazUrl;
        this.stepId = stepId;
        this.idAppeaz = idAppeaz;
        this.appeazRole = appeazRole;
        this.shadowPlaceholder = shadowPlaceholder;
        this.isPhotoImport = isPhotoImport;

        this.operation = new AddDmOperation(this.viewerService, this.names[0], idAppeaz, appeazUrl, appeazRole, stepId,
            dynamicModifications, rank, shadowPlaceholder, isPhotoImport);
    }

    buildReverseOperation(dynamicModificationIds: any): void {
        dynamicModificationIds = Array.isArray(dynamicModificationIds) ? dynamicModificationIds : [dynamicModificationIds];
        const addDmOperation = this.operation as AddDmOperation;
        addDmOperation.getDynamicModification().forEach((element, index) => {
            element.id = dynamicModificationIds[index];
        });

        this.reverseOperation = new DeleteDmOperation(this.viewerService, this.names[0], this.idAppeaz, this.appeazUrl
            , this.appeazRole, this.stepId, dynamicModificationIds, this.isPhotoImport);
    }

    do(): Observable<any> {
        return super.do();
    }

    undo(): Observable<any> {
        return super.undo();
    }

}
